module.exports = __webpack_public_path__ + "img/godzila.e2ff986e.jpg";